import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ControlsOf, FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { Observable } from 'rxjs';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

interface Login {
  username: string;
  password: string;
}

@Component({
  selector: 'digital-platform-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup<ControlsOf<Login>>;
  public errorMsg: string;
  public message$: Observable<string>;

  constructor(
    private formBuilder: FormBuilder,
    private facade: LoginSessionFacadeService
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.message$ = this.facade.message$;
  }

  onLoginSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.loginForm.updateValueAndValidity();
      return;
    }

    const { username, password } = this.loginForm.value;
    this.facade.login(username.trim(), password);
  }

  errorHandling = (control: string, error: string) =>
    this.loginForm.touched && this.loginForm.controls[control].hasError(error);
}
